import { apiDaInscricao } from "../../../servicos/axios";

export type EditarAgendamentoPayload = {
  id: number;
  dataInicial: string;
  dataFinal: string;
  pessoa: {
    nome: string;
    cpf: string;
    telefoneCelular: string;
  };
};

export const editarAgendamento = async (payload: EditarAgendamentoPayload) => {
  const api = apiDaInscricao();
  const { data } = await api.put("/agendamento/Editar", payload);
  return data?.agendamento ?? data;
};
